var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgRent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 81,
    viewBox: "0 0 94 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4H83V75H11V4Z",
    fill: "#B0D2EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25C21 24.4477 21.4477 24 22 24H72C72.5523 24 73 24.4477 73 25V26C73 26.5523 72.5523 27 72 27H22C21.4477 27 21 26.5523 21 26V25Z",
    fill: "#D6E8F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 32C21 31.4477 21.4477 31 22 31H72C72.5523 31 73 31.4477 73 32V33C73 33.5523 72.5523 34 72 34H22C21.4477 34 21 33.5523 21 33V32Z",
    fill: "#D6E8F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39C21 38.4477 21.4477 38 22 38H72C72.5523 38 73 38.4477 73 39V40C73 40.5523 72.5523 41 72 41H22C21.4477 41 21 40.5523 21 40V39Z",
    fill: "#D6E8F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0212 79.0667H32.9805V57.0046C32.9805 54.6107 34.9213 52.6699 37.3151 52.6699H56.6866C59.0804 52.6699 61.0205 54.6107 61.0205 57.0046V79.0667H61.0212Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4082 52.6699H48.5922V79.0667H45.4082V52.6699Z",
    fill: "#4D86B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 77C0 75.8954 0.895431 75 2 75H91.75C92.8546 75 93.75 75.8954 93.75 77V78.93C93.75 80.0346 92.8546 80.93 91.75 80.93H2C0.895431 80.93 0 80.0346 0 78.93V77Z",
    fill: "#031C2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C5 0.895433 5.89543 0 7 0H86.75C87.8546 0 88.75 0.895431 88.75 2V3.93C88.75 5.03457 87.8546 5.93 86.75 5.93H7C5.89543 5.93 5 5.03457 5 3.93V2Z",
    fill: "#4B81AC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRent);
export default __webpack_public_path__ + "static/media/imgRent.8995d1b6e0650e22534f725f5e1b864f.svg";
export { ForwardRef as ReactComponent };